import AMapLoader from '@amap/amap-jsapi-loader';
import '@amap/amap-jsapi-types';
import { ClusterGD } from './widgets/Cluster/gd/ClusterGD';
import { DrawSteet } from './widgets/DrawStreet/gd/DrawStreet';
import { DrawOverlays } from './widgets/DrawOverlays/gd/DrawOverlays';
import { GeometrySearchGD } from './widgets/GeometrySearch/gd/GeometrySearchGD';
import { HeatMapGD } from './widgets/HeatMap/gd/HeatMapGD';
import { JurisdictionPoliceGD } from './widgets/JurisdictionPolice/gd/JurisdictionPoliceGD';
import Route from './widgets/Route/gd/RouteGD';
import RoutePoint from './widgets/XinKong/RoutePoint';
import { OverlayGaode } from '@/plugin/gis-viewer/widgets/Overlays/gd/OverlayGaode';
import {
  ICenterLevel,
  ICustomTip,
  IDefinitionParameter,
  IDistrictParameter,
  IDrawOverlays,
  IFindParameter,
  IGeometrySearchParameter,
  IHeatImageParameter,
  IHeatParameter,
  ILayerConfig,
  IMapContainer,
  IOverlayClusterParameter,
  IOverlayDelete,
  IOverlayParameter,
  IPointGeometry,
  IPopUpTemplate,
  IResult,
  ISelectRouteHitTest,
  ISelectRouteParam,
  ISelectRouteResult,
  ISignalPhaseInfo,
  IStreetParameter,
  ISumoConnectInfo,
  ITrackParameter,
  IRouteParameter,
} from '@/types/map';

export default class MapAppGaode implements IMapContainer {
  public view!: AMap.Map;
  public baseLayers: Array<any> = [];
  public showGisDeviceInfo: any;
  public layerLoaded: any;
  public mouseGisDeviceInfo: any;
  public mapClick: any;

  public async initialize(mapConfig: any, mapContainer: string): Promise<void> {
    let apiUrl = mapConfig.arcgis_api || mapConfig.api_url || mapConfig.apiUrl;
    let plugins = ['AMap.DistrictSearch', 'AMap.CustomLayer', 'AMap.ControlBar', 'AMap.MarkerClusterer', 'AMap.Driving', 'AMap.Walking', 'AMap.Riding'];
    let version = '1.0';
    if (apiUrl.indexOf('v=2') > -1) {
      plugins.push('AMap.HeatMap');
      plugins.push('AMap.MouseTool');
      version = '2.0';
    } else {
      plugins.push('AMap.Heatmap');
    }
    let key = this.getQueryString(apiUrl, 'key');
    let v = this.getQueryString(apiUrl, 'v');
    await AMapLoader.load({
      key: key,
      version: v,
      plugins: plugins,
    });
    //this.destroy();
    this.view = new AMap.Map(mapContainer, mapConfig.options);

    (this.view as any).version = version;
    (this.view as any).mapOptions = mapConfig.options;
    // (this.view as any).plugin(["AMap.MouseTool"], function () {
    //   //异步同时加载多个插件
    //   // 以下是鼠标工具插件
    //   const mouseTool = new (this.view as any).MouseTool(this.view);
    //   // mouseTool.rule();// 用户手动绘制折线图,测量距离
    //   mouseTool.measureArea(); // 测量面积
    // }
    this.view.on('click', async evt => {
      let mp = evt.lnglat;
      this.mapClick({
        x: mp.lng,
        y: mp.lat,
        lng: mp.lng,
        lat: mp.lat,
      });
    });
    return new Promise(resole => {
      this.view.on('complete', () => {
        if (mapConfig.baseLayers) {
          mapConfig.baseLayers.forEach((element: any) => {
            this.createLayer(this.view, element);
          });
        }
        resole();
      });
    });
  }

  private getQueryString(url: string, name: string): string {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); //构造一个含有目标参数的正则表达式对象
    let search = url.split('?')[1];
    let r = search.match(reg); //匹配目标参数
    if (r != null) {
      return decodeURIComponent(r[2]);
    }
    return ''; //返回参数值
  }
  public createLayer(view: any, layer: any) {
    switch (layer.type) {
      case 'traffic':
        let trafficlayer = new AMap.TileLayer.Traffic({
          autoRefresh: true, //是否自动刷新，默认为false
          interval: layer.interval || 60, //刷新间隔，默认180s
          zooms: layer.zooms || [3, 17],
          opacity: layer.opacity || 1,
          zIndex: layer.zIndex || 4,
        });
        if (layer.visible !== false) {
          view.add(trafficlayer);
        }
        this.baseLayers.push({
          label: layer.label || '',
          type: layer.type || '',
          layer: trafficlayer,
          visible: layer.visible !== false,
        });
        break;
    }
  }
  private destroy() {
    OverlayGaode.destroy();
    ClusterGD.destroy();
    HeatMapGD.destroy();
    JurisdictionPoliceGD.destroy();
    DrawSteet.destroy();
    Route.destroy();
    RoutePoint.destroy();
    GeometrySearchGD.destroy();
  }
  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    const overlay = OverlayGaode.getInstance(this.view);
    overlay.showGisDeviceInfo = this.showGisDeviceInfo;
    overlay.mouseGisDeviceInfo = this.mouseGisDeviceInfo;
    return await overlay.addOverlays(params);
  }

  public async findFeature(params: IFindParameter): Promise<IResult> {
    const overlay = OverlayGaode.getInstance(this.view);
    return await overlay.findFeature(params);
  }
  public async findLayerFeature(params: IFindParameter) {}
  public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
    const cluster = ClusterGD.getInstance(this.view);
    cluster.showGisDeviceInfo = this.showGisDeviceInfo;
    return await cluster.addOverlaysCluster(params);
  }

  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    const heatmap = HeatMapGD.getInstance(this.view);
    return await heatmap.addHeatMap(params);
  }

  public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlay = OverlayGaode.getInstance(this.view);
    return await overlay.deleteOverlays(params);
  }

  public async deleteOverlaysCluster(params: IOverlayDelete) {
    const cluster = ClusterGD.getInstance(this.view);
    await cluster.deleteOverlaysCluster(params);
  }

  public async deleteAllOverlays() {
    const overlay = OverlayGaode.getInstance(this.view);
    await overlay.deleteAllOverlays();
  }

  public async deleteAllOverlaysCluster() {
    const cluster = ClusterGD.getInstance(this.view);
    await cluster.deleteAllOverlaysCluster();
  }
  public async deleteHeatMap(params: ILayerConfig) {
    const overlay = HeatMapGD.getInstance(this.view);
    await overlay.deleteHeatMap(params);
  }
  public async setMapCenter(params: IPointGeometry) {
    let x = params.x;
    let y = params.y;
    let center = new AMap.LngLat(x, y);
    this.view.setCenter(center);
  }

  public async setMapCenterAndLevel(params: ICenterLevel) {
    let x = params.x;
    let y = params.y;
    let center = new AMap.LngLat(x, y);
    let level = params.level || this.view.getZoom();
    this.view.setZoomAndCenter(level, center);
  }

  public showLayer(params: ILayerConfig) {
    console.log(params);
    console.log('添加了 啊', this.baseLayers);
    this.baseLayers.forEach(baselayer => {
      if ((params.label && baselayer.label === params.label) || (params.type && baselayer.type === params.type)) {
        if (!baselayer.visible) {
          this.view.add(baselayer.layer);
          baselayer.visible = true;
        }
      }
    });
  }
  public hideLayer(params: ILayerConfig) {
    this.baseLayers.forEach(baselayer => {
      if ((params.label && baselayer.label === params.label) || (params.type && baselayer.type === params.type)) {
        if (baselayer.visible) {
          this.view.remove(baselayer.layer);
          baselayer.visible = false;
        }
      }
    });
  }

  public async showJurisdiction() {}
  public async hideJurisdiction() {}

  public async showDistrictMask(param: IDistrictParameter) {
    const jurisdiction = JurisdictionPoliceGD.getInstance(this.view);
    await jurisdiction.showDistrictMask(param);
  }
  public async hideDistrictMask() {
    const jurisdiction = JurisdictionPoliceGD.getInstance(this.view);
    await jurisdiction.hideDistrictMask();
  }
  public async showRoad(param: { ids: string[] }) {
    const road = DrawSteet.getInstance(this.view);
    await road.showRoad(param);
  }
  public async hideRoad() {
    const road = DrawSteet.getInstance(this.view);
    await road.hideRoad();
  }
  public async showStreet() {
    const jurisdiction = JurisdictionPoliceGD.getInstance(this.view);
    await jurisdiction.showStreet();
  }
  public async hideStreet() {
    const jurisdiction = JurisdictionPoliceGD.getInstance(this.view);
    await jurisdiction.hideStreet();
  }
  public async locateStreet(param: IStreetParameter) {
    const jurisdiction = JurisdictionPoliceGD.getInstance(this.view);
    await jurisdiction.locateStreet(param);
  }
  public setMapStyle(param: string) {
    this.view.setMapStyle(param);
  }
  public async routeSearch(params: IRouteParameter): Promise<IResult> {
    const route = Route.getInstance(this.view);
    return await route.routeSearch(params);
  }
  public clearRouteSearch() {
    const route = Route.getInstance(this.view);
    route.clearRouteSearch();
  }
  public showRoutePoint(params: any) {
    const rtp = RoutePoint.getInstance(this.view);
    rtp.showRoutePoint(params);
  }
  public clearRoutePoint() {
    const rtp = RoutePoint.getInstance(this.view);
    rtp.clearRoutePoint();
  }

  public async addDrawLayer(params: any): Promise<IResult> {
    return { status: 0, message: '' };
  }
  public clearDrawLayer(params: ILayerConfig) {}

  public showMigrateChart(params: any) {}
  public hideMigrateChart() {}
  public showBarChart(params: any) {}
  public hideBarChart() {}
  public addHeatImage(params: IHeatImageParameter) {}
  public deleteHeatImage() {}

  public async startGeometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
    let geometrySearch = GeometrySearchGD.getInstance(this.view);
    return await geometrySearch.startGeometrySearch(params);
  }
  public clearGeometrySearch() {
    let geometrySearch = GeometrySearchGD.getInstance(this.view);
    geometrySearch.clearGeometrySearch();
  }
  public async showDgene(params: any): Promise<IResult> {
    return { status: 0, message: '' };
  }
  public hideDgene() {}
  public async addDgeneFusion(params: any): Promise<IResult> {
    return { status: 0, message: '' };
  }
  public async restoreDegeneFsion(): Promise<IResult> {
    return { status: 0, message: '' };
  }
  public showCustomTip(params: ICustomTip) {}
  public showDgeneOutPoint(params: any) {}
  public changeDgeneOut() {}

  public async initializeRouteSelect(params: ISelectRouteParam) {}
  public async showSelectedRoute(params: ISelectRouteResult) {}
  public async playSelectedRoute(speed: number) {}
  public stopPlaySelectedRoute() {}
  public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: '' };
  }
  public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: '' };
  }

  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
    const drawoverlay = DrawOverlays.getInstance(this.view);
    return await drawoverlay.startDrawOverlays(params);
  }
  public async stopDrawOverlays(): Promise<void> {
    const drawoverlay = DrawOverlays.getInstance(this.view);
    return await drawoverlay.stopDrawOverlays();
  }
  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {}
  public async getDrawOverlays(): Promise<IResult> {
    const drawoverlay = DrawOverlays.getInstance(this.view);
    return await drawoverlay.getDrawOverlays();
  }
  public async startLayerSearch(params: IGeometrySearchParameter): Promise<IResult> {
    return { status: 0, message: '' };
  }
  public async startLayerDefinition(params: IDefinitionParameter): Promise<void> {}
  public async startTrackPlay(params: ITrackParameter): Promise<void> {}
  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    return { status: 0, message: '' };
  }
  public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
    return { status: 0, message: '' };
  }

  public async connectSumoSimulation(params: ISumoConnectInfo): Promise<IResult> {
    return { status: 0, message: '' };
  }

  public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
    return { status: -2, message: 'no function' };
  }
  public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
    return { status: -2, message: 'no function' };
  }

  public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    return { status: -2, message: 'no function' };
  }
  public async showPopup(params: IPopUpTemplate) {}

  public toggleWidget(params: string[]) {}
}
